export default __webpack_public_path__ + "static/media/gallery_02.d3de9c28.jpg";